import React from "react";
import "./PrivacyPolicy.css"; // Ensure you create this CSS file for styling
import { Link } from "react-router-dom";

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> January 23rd, 2025</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to The Futsal Directory. Your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your personal information when you visit our website.
      </p>

      <h2>2. Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li>Personal information (such as name, email, phone number) when you register or contact us.</li>
        <li>Usage data, including IP address, browser type, and pages visited.</li>
        <li>Cookies and tracking technologies to improve user experience.</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <p>We use the collected data to:</p>
      <ul>
        <li>Provide and maintain our services.</li>
        <li>Improve user experience and website functionality.</li>
        <li>Communicate with you regarding updates, promotions, or support.</li>
        <li>Comply with legal requirements.</li>
      </ul>

      <h2>4. Third-Party Sharing</h2>
      <p>We do not sell or rent your personal data. However, we may share your information with:</p>
      <ul>
        <li>Service providers assisting with website operations.</li>
        <li>Legal authorities if required by law.</li>
        <li>Analytics tools to understand website performance.</li>
      </ul>

      <h2>5. Cookies and Tracking</h2>
      <p>
        We use cookies to enhance your experience. You can manage or disable cookies through your browser settings.
      </p>

      <h2>6. Your Privacy Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Request access to your personal data.</li>
        <li>Correct inaccurate information.</li>
        <li>Delete your data upon request.</li>
        <li>Opt-out of marketing communications.</li>
      </ul>

      <h2>7. Data Security</h2>
      <p>
        We take reasonable security measures to protect your data, but no method is 100% secure. Please use strong passwords and safeguard your personal information.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. Any changes will be posted on this page, and you are encouraged to review the policy periodically.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at:
      </p>
      <p><strong>Email:</strong> <a href="mailto:thefutsaldirectory@gmail.com">thefutsaldirectory@gmail.com</a></p>
      {/* <p><strong>Address:</strong> 123 Example Street, City, Country</p> */}

      <div className="privacy-back">
        <Link to="/">← Back to Home</Link>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
